"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * An error thrown when an issue is encountered while parsing a formula.
 */
var ParseError = /** @class */ (function (_super) {
    __extends(ParseError, _super);
    function ParseError(message, index) {
        var _this = _super.call(this, message) || this;
        _this.index = index;
        // Set the prototype manually so checking `instanceof ParseError` works as expected.
        // See https://github.com/Microsoft/TypeScript-wiki/blob/master@%7B2020-06-05T22:30:17Z%7D/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, ParseError.prototype);
        return _this;
    }
    Object.defineProperty(ParseError.prototype, "errorValue", {
        get: function () {
            return "#ERROR!";
        },
        enumerable: false,
        configurable: true
    });
    return ParseError;
}(Error));
exports.default = ParseError;
//# sourceMappingURL=parseError.js.map